export default __webpack_public_path__ + "static/media/F0005.b5579c42.png";